import React from 'react';

const PlusIcon = props => (
  <svg
    fill="none"
    height="10"
    viewBox="0 0 10 10"
    width="10"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.46875 4.3125C9.57031 4.3125 9.67188 4.36328 9.74805 4.43945C9.82422 4.51562 9.875 4.61719 9.875 4.71875V5.53125C9.875 5.6582 9.82422 5.75977 9.74805 5.83594C9.67188 5.91211 9.57031 5.9375 9.46875 5.9375H5.8125V9.59375C5.8125 9.7207 5.76172 9.82227 5.68555 9.89844C5.60938 9.97461 5.50781 10 5.40625 10H4.59375C4.4668 10 4.36523 9.97461 4.28906 9.89844C4.21289 9.82227 4.1875 9.7207 4.1875 9.59375V5.9375H0.53125C0.404297 5.9375 0.302734 5.91211 0.226562 5.83594C0.150391 5.75977 0.125 5.6582 0.125 5.53125V4.71875C0.125 4.61719 0.150391 4.51562 0.226562 4.43945C0.302734 4.36328 0.404297 4.3125 0.53125 4.3125H4.1875V0.65625C4.1875 0.554688 4.21289 0.453125 4.28906 0.376953C4.36523 0.300781 4.4668 0.25 4.59375 0.25H5.40625C5.50781 0.25 5.60938 0.300781 5.68555 0.376953C5.76172 0.453125 5.8125 0.554688 5.8125 0.65625V4.3125H9.46875Z"
      fill="#999999"
    />
  </svg>
);

export default PlusIcon;
